// The page asked for, carried across a Dex login; see docs/dex-implementation-plan.md section 17.
const RETURN_PATH_KEY = 'km_return_path'

/** Tenant root for the current URL, e.g. `/acme`. */
function tenantRootPath(): string {
  const tenantId = window.location.pathname.split('/')[1] || ''
  return `/${tenantId}`
}

// Call once on load, before anything can redirect; a no-op on the tenant root.
export function rememberReturnPath(): void {
  const { pathname, search } = window.location
  const root = tenantRootPath()
  if (pathname === root || pathname === `${root}/`) return
  sessionStorage.setItem(RETURN_PATH_KEY, `${pathname}${search}`)
}

// Cleared on read; null unless the value is a same-origin path, since `//host` would open-redirect.
export function consumeReturnPath(): string | null {
  const target = sessionStorage.getItem(RETURN_PATH_KEY)
  sessionStorage.removeItem(RETURN_PATH_KEY)
  if (!target || !target.startsWith('/') || target.startsWith('//')) return null
  if (target === `${window.location.pathname}${window.location.search}`) return null
  return target
}
